import type { Outfit } from '@/types/closet'

/** Legacy records remain available to the owner, outside the public collection. */
export function hasTimelineMedia(outfit: Outfit) {
  const media = outfit.lookbookMedia
  return Boolean(
    media?.approvedAt &&
    media.imageModel === 'openai/gpt-image-2.5/flare/edit' &&
    media.videoModel === 'minimax/h3-max/image-to-video' &&
    media.rotationUrl &&
    media.rotationUrlDark &&
    media.timelineUrl &&
    media.timelineUrlDark,
  )
}
